import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { viewTypeOptions } from '../containers/plan-menu/constants'
import { usePlanMenuStore } from '../zustand/plan-menu/use-plan-menu-store'

export const usePlanMenuListViewControl = () => {
  const { search } = useLocation()
  const searchParams = new URLSearchParams(search)
  const viewTypeFromUrl = searchParams.get('view')
  const isKnownViewType =
    Object.values(viewTypeOptions).includes(viewTypeFromUrl)

  const storedViewType = usePlanMenuStore((state) => state.planMenuViewType)
  const setStoredViewType = usePlanMenuStore(
    (state) => state.setPlanMenuViewType
  )

  // the URL wins whenever it carries a view, and becomes the fallback for when
  // the plan menu is reached without one (coming back from another page, where
  // the links have no view to carry)
  useEffect(() => {
    if (isKnownViewType && viewTypeFromUrl !== storedViewType) {
      setStoredViewType(viewTypeFromUrl)
    }
  }, [isKnownViewType, viewTypeFromUrl, storedViewType, setStoredViewType])

  return {
    viewType: isKnownViewType ? viewTypeFromUrl : storedViewType
  }
}
